import { createContext, ReactNode, useContext } from 'react';

import { TBlock } from 'detailsv2/__blocks';

import { useLandingV2Context } from '../../../context';
import { BLOCKS_CONFIG } from '../blocks/configs';
import { IBlockConfig } from '../blocks/types';
import * as types from './types';

export interface IBlockContext<T extends TBlock = TBlock> {
  readonly?: boolean;
  block: T;
  // TODO make optional
  index: number[];
  // TODO make optional
  config: IBlockConfig;
  onAdd?: types.TAddBlockHandlerFn;
  onUpdate?: types.TUpdateBlockHandlerFn;
  onDelete?: types.TDeleteBlockHandlerFn;
  onAddBlockInsideSpoiler?: types.TAddBlockInsideSpoilerFn;
  onUpdateBlockInsideSpoiler?: types.TUpdateBlockInsideSpoilerFn;
  onDeleteBlockInsideSpoiler?: types.TDeleteBlockInsideSpoilerFn;
  availableInBasic?: boolean;
  outerDisabledAddingBlocks?: boolean;
  isInsideAccordion?: boolean;
}

export interface IBlockContextProviderProps {
  value: types.IBlockProps;
  children: ReactNode;
}

const BlockContext = createContext<IBlockContext>({
  block: {} as TBlock,
  index: [0],
  config: {} as IBlockConfig,
  isInsideAccordion: false,
});

export const useBlockContext = <T extends TBlock>() => useContext(BlockContext) as IBlockContext<T>;

export const BlockContextProvider = ({ value, children }: IBlockContextProviderProps) => {
  const contextValue = useBlockContextValue(value);
  return <BlockContext.Provider value={contextValue}>{children}</BlockContext.Provider>;
};

export function useBlockContextValue({
  readonly,
  disabledAddingBlocks,
  block,
  index,
  isInsideAccordion,
  onAdd,
  onDelete,
  onUpdate,
  onAddBlockInsideSpoiler,
  onUpdateBlockInsideSpoiler,
  onDeleteBlockInsideSpoiler,
}: types.IBlockProps): IBlockContext {
  const { readonly: landingReadonly } = useLandingV2Context();
  const { meta, type } = block;

  const config = BLOCKS_CONFIG[type];

  return {
    block,
    index,
    config,
    readonly: landingReadonly || (meta?.readonly ?? readonly),
    outerDisabledAddingBlocks: disabledAddingBlocks,
    isInsideAccordion,
    onAdd,
    onDelete,
    onUpdate,
    onAddBlockInsideSpoiler,
    onUpdateBlockInsideSpoiler,
    onDeleteBlockInsideSpoiler,
  };
}
